export default {
  props: ['projectInfo'],
  data() {
    return {
      bidGeneralSituation: 7, // 其他
      otherForm: {
        otherMassifInfo: ''
      },
      rules: {
        otherMassifInfo: [
          { required: true, message: '请输入其他标的信息', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    projectInfo: {
      handler: function(){
        if(this.projectInfo && this.projectInfo.assetsInfo) {
          const assetsInfoList = JSON.parse(this.projectInfo.assetsInfo);
          let assetsInfo = null;
          assetsInfoList.map(item => {
            // item = JSON.parse(item);
            if(item.bidGeneralSituation === this.bidGeneralSituation) {
              assetsInfo = item;
            }
          });
          if (assetsInfo) {
            this.otherForm.otherMassifInfo = assetsInfo.otherMassifInfo;
          }
        }
      },
      immediate: true // 初始化执行
    }
  },
  methods: {
    clear(){
      if( this.projectInfo.projectType === 1) return false;
      this.otherForm.otherMassifInfo = '';

      // 清空红色必填标示
      if(this.$refs['otherForm']) {
        this.$refs['otherForm'].resetFields();
      }
    },
    test() {
      return new Promise((resolve, reject) => {
        this.$refs['otherForm'].validate((valid) => {
          if (valid) {
            resolve({
              ...this.otherForm,
              bidGeneralSituation: this.bidGeneralSituation
            });
          } else {
            reject();
          }
        });
      });
    }
  }
};
